import styles from "./Section.module.less";
import clsx from "clsx";

export const SectionCol = ({ className, children }) => {
  return <div className={clsx(styles.SectionCol, className)}>{children}</div>;
};
